module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAS1JREFUaAXtms0KAjEMhFvx6sGzP69qFPEh/XuVOhV3kbLbw6ahCSRQdlWafDPTPSiGIFgpJcpLcIRca4BfsIayJQLU14H872pDBIBvf9DlrW4RoN1ivUvq4rV6EUcXERQUUvAkFOQQgiehIgZAeBKeREMH/Dg1NJPVypNg2ddwsyfR0ExWqyVJRGxKrKl9Np9jjJRHr/rMZ089wXfKXdbsVv0aZBFmExhts3qEsoDvc2BVwPgQj1FouMGZtvs92uF7HSE4f8Cy+WveD/6Fa62ol7nVuSDOzjt81SWJD607v4eAJ1atSMI4dk8QOzzbxSUNrDu/g4BH7cDjM1pijPgegDm8uMtTA6w7v4GAO1ataEq4mvdAnv8fMVe64QcXQT8lwgb8jAhb8IUIUfgPIaG9kEof8H4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/ic-arrow-right.png
// module id = 332
// module chunks = 0